import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-tooltip-help',
  templateUrl: './tooltip-help.component.html',
  styleUrls: ['./tooltip-help.component.scss']
})
export class TooltipHelpComponent implements OnInit {
  @Output('closePopup') closePopup = new EventEmitter();
  @Input() title:string;
  @Input() contect:HTMLElement;
  constructor() { }

  ngOnInit(): void {
    console.log(this.contect);
  }

}
